// Permission catalog — SINGLE SOURCE OF TRUTH (ТЗ "7.07.2026 ТЗ підписки", §6).
// Дублируется дословно в 3 проектах (API / front / admin): деплоятся раздельно,
// admin крутится в своём Docker (примонтирован только ./admin). Менять — во всех трёх.
//   - score68-api/constants/permissions.js   (канонический)
//   - score68-front/src/constants/permissions.js
//   - admin/src/permissions.js

export const PERMISSIONS = {
  LIVE_VIEW: "LIVE_VIEW",
  LIVE_SORT: "LIVE_SORT",
  LIVE_FAVORITE: "LIVE_FAVORITE",
  LIVE_SIGNAL: "LIVE_SIGNAL",
  LIVE_FILTER: "LIVE_FILTER",
  LIVE_DATA: "LIVE_DATA",

  PREMATCH_VIEW: "PREMATCH_VIEW",
  PREMATCH_FAVORITE: "PREMATCH_FAVORITE",
  PREMATCH_SIGNAL: "PREMATCH_SIGNAL",
  PREMATCH_SORT: "PREMATCH_SORT",
  PREMATCH_FILTER: "PREMATCH_FILTER",
  PREMATCH_DATA: "PREMATCH_DATA",

  TICKER_VIEW: "TICKER_VIEW",
  TICKER_FAVORITE: "TICKER_FAVORITE",
  TICKER_SIGNAL: "TICKER_SIGNAL",
  TICKER_SORT: "TICKER_SORT",
  TICKER_FILTER: "TICKER_FILTER",
  TICKER_DATA: "TICKER_DATA",

  ADS_DISABLED: "ADS_DISABLED",
};

// Группировка для чекбокс-редактора в админке (порядок = порядок в UI).
export const PERMISSION_GROUPS = [
  {
    key: "LIVE",
    label: "LIVE",
    permissions: [
      "LIVE_VIEW",
      "LIVE_SORT",
      "LIVE_FAVORITE",
      "LIVE_SIGNAL",
      "LIVE_FILTER",
      "LIVE_DATA",
    ],
  },
  {
    key: "PREMATCH",
    label: "PREMATCH",
    permissions: [
      "PREMATCH_VIEW",
      "PREMATCH_FAVORITE",
      "PREMATCH_SIGNAL",
      "PREMATCH_SORT",
      "PREMATCH_FILTER",
      "PREMATCH_DATA",
    ],
  },
  {
    key: "TICKER",
    label: "TICKER",
    permissions: [
      "TICKER_VIEW",
      "TICKER_FAVORITE",
      "TICKER_SIGNAL",
      "TICKER_SORT",
      "TICKER_FILTER",
      "TICKER_DATA",
    ],
  },
  {
    key: "GLOBAL",
    label: "Global",
    permissions: ["ADS_DISABLED"],
  },
];

// English descriptions (editor tooltips / NeedSub copy).
export const PERMISSION_DESCRIPTIONS = {
  LIVE_VIEW: "View the LIVE tab",
  LIVE_SORT: "Sort data in the LIVE section",
  LIVE_FAVORITE: "Add favorites in LIVE",
  LIVE_SIGNAL: "Receive LIVE signals",
  LIVE_FILTER: "Filter data in the LIVE section",
  LIVE_DATA: "View full match data (Full Match Data) in the LIVE section",
  PREMATCH_VIEW: "View the Prematch tab",
  PREMATCH_FAVORITE: "Add favorites in Prematch",
  PREMATCH_SIGNAL: "Receive Prematch signals",
  PREMATCH_SORT: "Sort data in the Prematch section",
  PREMATCH_FILTER: "Filter data in the Prematch section",
  PREMATCH_DATA: "View full match data in the Prematch section",
  TICKER_VIEW: "Ticker reading mode",
  TICKER_FAVORITE: "Add favorites in Ticker",
  TICKER_SIGNAL: "Receive Ticker signals",
  TICKER_SORT: "Sort data in the Ticker section",
  TICKER_FILTER: "Filter data in the Ticker section",
  TICKER_DATA: "View full match data in the Ticker section",
  ADS_DISABLED: "Disable ads (ad-free experience)",
};

// Плоский список всех 19 — для валидации.
export const ALL_PERMISSIONS = Object.values(PERMISSIONS);
